import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEquipo } from '../context/EquipoContext';
import { useAuth }   from '../context/AuthContext';
import { getJugadores, agregarJugador, eliminarJugador } from '../services/api';

const API = process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000';

export default function Nomina() {
  const navigate = useNavigate();
  const { equipo, equipos, cambiarEquipo, borrarEquipo, deporteActivo } = useEquipo();
  const { user, token } = useAuth();

  const esFutbol = !deporteActivo || deporteActivo === 'futbol';

  const [jugadores,          setJugadores]          = useState([]);
  const [parejas,            setParejas]            = useState([]);
  const [cargando,           setCargando]           = useState(false);
  const [agregando,          setAgregando]          = useState(false);
  const [guardando,          setGuardando]          = useState(false);
  const [eliminandoEq,       setEliminandoEq]       = useState(false);
  const [intentandoEliminar, setIntentandoEliminar] = useState(false);
  const [error,              setError]              = useState('');
  const [form, setForm] = useState({ nombre: '', celular: '', edad: '', peso: '' });
  const [editandoPareja,  setEditandoPareja]  = useState(null); // id de pareja editando
  const [formPareja,      setFormPareja]      = useState({ nombre_companero: '', celular_companero: '' });
  const [guardandoPareja, setGuardandoPareja] = useState(false);

  useEffect(() => {
    if (!equipo?.id) return;
    setCargando(true);
    if (esFutbol) {
      getJugadores(equipo.id)
        .then(data => { if (Array.isArray(data)) setJugadores(data); })
        .catch(() => {})
        .finally(() => setCargando(false));
    } else {
      // Cargar parejas del jugador
      fetch(`${API}/api/parejas/jugador/${user?.id}`)
        .then(r => r.json())
        .then(data => {
          if (Array.isArray(data)) {
            setParejas(data.filter(p => p.deporte === deporteActivo));
          }
        })
        .catch(() => {})
        .finally(() => setCargando(false));
    }
  }, [equipo?.id, esFutbol, deporteActivo, user?.id]);

  const handleAgregar = async () => {
    if (!form.nombre.trim()) { setError('El nombre es obligatorio'); return; }
    setGuardando(true); setError('');
    try {
      const data = await agregarJugador({
        equipo_id: equipo.id,
        nombre:    form.nombre.trim(),
        celular:   form.celular.trim() || null,
        edad:      form.edad ? parseInt(form.edad) : null,
        peso:      form.peso ? parseInt(form.peso) : null,
      }, token);
      if (data.error) { setError(data.error); return; }
      setJugadores(prev => [...prev, data]);
      setForm({ nombre: '', celular: '', edad: '', peso: '' });
      setAgregando(false);
    } catch { setError('Error de conexión'); }
    finally  { setGuardando(false); }
  };

  const handleEliminarJugador = async (id) => {
    if (!window.confirm('¿Eliminar este jugador?')) return;
    await eliminarJugador(id, token);
    setJugadores(prev => prev.filter(j => j.id !== id));
  };

  const handleEliminarPareja = async (parejaId) => {
    if (!window.confirm('¿Eliminar esta pareja del historial?')) return;
    try {
      await fetch(`${API}/api/parejas/${parejaId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      setParejas(prev => prev.filter(p => p.id !== parejaId));
    } catch { alert('Error al eliminar pareja'); }
  };

  const handleGuardarPareja = async () => {
    setGuardandoPareja(true);
    try {
      const parejaAntes = parejas.find(p => p.id === editandoPareja);
      const celularNuevo = formPareja.celular_companero.trim();
      const celularCambio = celularNuevo && celularNuevo !== parejaAntes?.celular_companero;

      await fetch(`${API}/api/parejas/${editandoPareja}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          nombre_companero:  formPareja.nombre_companero.trim() || null,
          celular_companero: celularNuevo || null,
        }),
      });

      // Si ingresó celular nuevo de compañero no registrado → enviar WSP de invitación
      if (celularCambio && formPareja.nombre_companero.trim()) {
        try {
          await fetch(`${API}/api/invitaciones`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({
              desafio_id: null, // invitación libre sin desafío
              tipo:       'companero_libre',
              nombre:     formPareja.nombre_companero.trim(),
              celular:    celularNuevo,
              invitador:  user?.nombre,
              deporte:    deporteActivo,
            }),
          });
        } catch { /* WSP falla silenciosamente */ }
      }

      setParejas(prev => prev.map(p => p.id === editandoPareja
        ? { ...p, nombre_companero: formPareja.nombre_companero, celular_companero: celularNuevo }
        : p
      ));
      setEditandoPareja(null);
    } catch { alert('Error al guardar pareja'); }
    finally { setGuardandoPareja(false); }
  };

  const handleEliminarEquipo = async () => {
    if (esFutbol && jugadores.length > 0) {
      setIntentandoEliminar(true);
      return;
    }
    setIntentandoEliminar(false);
    const msg = esFutbol
      ? `¿Eliminar el equipo "${equipo?.nombre}"?`
      : `¿Eliminar tu perfil de ${deporteActivo === 'padel' ? 'Pádel' : 'Tenis'} "${equipo?.nombre}"?`;
    if (!window.confirm(msg + ' Esta acción no se puede deshacer.')) return;
    setEliminandoEq(true);
    const result = await borrarEquipo(equipo.id);
    setEliminandoEq(false);
    if (result.ok) navigate('/app/dashboard');
    else alert('Error al eliminar: ' + result.error);
  };

  const campoElo = esFutbol ? 'elo' : deporteActivo === 'padel' ? 'elo_padel' : 'elo_tenis';
  const eloActual = equipo?.[campoElo] || equipo?.elo || 1000;
  const deporteLabel = esFutbol ? 'Fútbol' : deporteActivo === 'padel' ? 'Pádel' : 'Tenis';

  return (
    <div style={styles.pagina}>
      <div style={styles.header}>
        <div style={styles.headerInner}>
          <div>
            <div style={styles.titulo}>{esFutbol ? 'Nómina' : 'Mis Parejas'}</div>
            <div style={styles.sub}>
              {esFutbol
                ? `${jugadores.length} jugador${jugadores.length !== 1 ? 'es' : ''}`
                : `${parejas.length} pareja${parejas.length !== 1 ? 's' : ''} · ${deporteLabel}`}
            </div>
          </div>
        </div>

        <div style={styles.selectorWrap}>
          <div style={styles.selectorLabel}>{esFutbol ? 'Equipo activo:' : 'Perfil activo:'}</div>
          <div style={styles.selectorChips}>
            {equipos.map(e => (
              <div
                key={e.id}
                onClick={() => cambiarEquipo(e.id)}
                style={{
                  ...styles.selectorChip,
                  background: equipo?.id === e.id ? 'white' : 'rgba(255,255,255,0.08)',
                  color:      equipo?.id === e.id ? '#141922' : 'rgba(255,255,255,0.5)',
                  fontWeight: equipo?.id === e.id ? 700 : 400,
                  border:     equipo?.id === e.id ? '2px solid white' : '2px solid rgba(255,255,255,0.1)',
                }}
              >
                {equipo?.id === e.id && <span style={{ color: '#FF6B1A', marginRight: 4 }}>●</span>}
                {e.nombre}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={styles.contenido}>

        {/* Card perfil/equipo activo */}
        <div style={styles.equipoCard}>
          <div style={{
            ...styles.equipoEscudo,
            background: esFutbol
              ? `linear-gradient(135deg, ${equipo?.colorPrincipal || '#FF6B1A'}, ${equipo?.colorSecundario || '#1A6BFF'})`
              : 'linear-gradient(135deg, #0D1117, #1A6BFF)',
          }}>
            {equipo?.nombre?.split(' ').map(p => p[0]).slice(0,2).join('').toUpperCase() || 'EQ'}
          </div>
          <div style={styles.equipoInfo}>
            <div style={styles.equipoNombre}>{equipo?.nombre || 'Sin perfil'}</div>
            <div style={styles.equipoMeta}>
              {equipo?.zona || ''}{equipo?.modalidades?.length > 0 ? ' · ' + equipo.modalidades.join(', ') : ''}
            </div>
            <div style={styles.capRow}>
              <span style={styles.capIcono}>👑</span>
              <span style={styles.capNombre}>{user?.nombre}</span>
              <span style={styles.capEmail}>{user?.email}</span>
            </div>
          </div>
          <div style={styles.equipoAcciones}>
            <div style={styles.eloTag}>ELO {eloActual}</div>
            {esFutbol && (
              <button style={styles.btnAgregar} onClick={() => { setAgregando(true); setError(''); }}>
                + Agregar jugador
              </button>
            )}
            <button
              style={{ ...styles.btnEliminarEquipo, opacity: eliminandoEq ? 0.6 : 1 }}
              onClick={handleEliminarEquipo}
              disabled={eliminandoEq}
            >
              {eliminandoEq ? 'Eliminando...' : `🗑 Eliminar ${esFutbol ? 'equipo' : 'perfil'}`}
            </button>
          </div>
        </div>

        {intentandoEliminar && jugadores.length > 0 && (
          <div style={styles.avisoEliminar}>
            ⚠️ Para eliminar este equipo primero debes eliminar los {jugadores.length} jugadores.
          </div>
        )}

        {/* Formulario agregar jugador (solo fútbol) */}
        {esFutbol && agregando && (
          <div style={styles.formCard}>
            <div style={styles.formTitulo}>Nuevo jugador — {equipo?.nombre}</div>
            <div style={styles.formGrid}>
              {[
                { key: 'nombre',  label: 'Nombre *',  placeholder: 'Nombre completo', type: 'text'   },
                { key: 'celular', label: 'Celular',   placeholder: '+56 9 1234 5678', type: 'text'   },
                { key: 'edad',    label: 'Edad',      placeholder: '25',              type: 'number' },
                { key: 'peso',    label: 'Peso (kg)', placeholder: '75',              type: 'number' },
              ].map(({ key, label, placeholder, type }) => (
                <div key={key}>
                  <div style={styles.formLabel}>{label}</div>
                  <input
                    style={styles.input} type={type}
                    value={form[key]}
                    onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))}
                    placeholder={placeholder}
                  />
                </div>
              ))}
            </div>
            {error && <div style={styles.error}>{error}</div>}
            <div style={styles.formBotones}>
              <button style={styles.btnCancelar} onClick={() => { setAgregando(false); setError(''); setForm({ nombre:'', celular:'', edad:'', peso:'' }); }}>Cancelar</button>
              <button style={{ ...styles.btnGuardar, opacity: guardando ? 0.7 : 1 }} onClick={handleAgregar} disabled={guardando}>
                {guardando ? 'Guardando...' : 'Guardar jugador'}
              </button>
            </div>
          </div>
        )}

        {/* Lista jugadores (fútbol) */}
        {esFutbol && (
          cargando ? (
            <div style={styles.cargando}>Cargando jugadores...</div>
          ) : jugadores.length === 0 ? (
            <div style={styles.vacio}>
              <div style={styles.vacioIcono}>👥</div>
              <div style={styles.vacioTitulo}>Sin jugadores en {equipo?.nombre}</div>
              <div style={styles.vacioSub}>Agrega los jugadores de este equipo.</div>
              <button style={styles.btnAgregarGrande} onClick={() => { setAgregando(true); setError(''); }}>
                + Agregar primer jugador
              </button>
            </div>
          ) : (
            <>
              <div style={styles.listaHeader}>{jugadores.length} jugador{jugadores.length !== 1 ? 'es' : ''}</div>
              <div style={styles.lista}>
                {jugadores.map((j, i) => (
                  <div key={j.id} style={styles.jugadorCard}>
                    <div style={styles.jugadorNum}>{i + 1}</div>
                    <div style={styles.jugadorAvatar}>{j.nombre.split(' ').map(p => p[0]).slice(0,2).join('')}</div>
                    <div style={styles.jugadorInfo}>
                      <div style={styles.jugadorNombre}>{j.nombre}</div>
                      <div style={styles.jugadorMeta}>
                        {[j.celular, j.edad && `${j.edad} años`, j.peso && `${j.peso} kg`].filter(Boolean).join(' · ')}
                      </div>
                    </div>
                    <button style={styles.btnEliminar} onClick={() => handleEliminarJugador(j.id)}>✕</button>
                  </div>
                ))}
              </div>
            </>
          )
        )}

        {/* Parejas (pádel/tenis) */}
        {!esFutbol && (
          cargando ? (
            <div style={styles.cargando}>Cargando parejas...</div>
          ) : parejas.length === 0 ? (
            <div style={styles.vacio}>
              <div style={styles.vacioIcono}>🤝</div>
              <div style={styles.vacioTitulo}>Sin historial de dobles</div>
              <div style={styles.vacioSub}>
                Al jugar partidos de dobles en {deporteLabel}, tus parejas aparecerán aquí con su ELO y estadísticas.
              </div>
            </div>
          ) : (
            <>
              <div style={styles.listaHeader}>{parejas.length} pareja{parejas.length !== 1 ? 's' : ''}</div>
              <div style={styles.lista}>
                {parejas.sort((a, b) => (b.elo || 1000) - (a.elo || 1000)).map((p, i) => {
                  const compañero = p.jugador1_id === user?.id ? p.jugador2_nombre : p.jugador1_nombre;
                  const derrotas  = (p.partidos || 0) - (p.victorias || 0) - (p.empates || 0);
                  const winRate   = p.partidos > 0 ? Math.round((p.victorias / p.partidos) * 100) : 0;
                  return (
                    <div key={p.id} style={{ marginBottom: 8 }}>
                      <div style={styles.jugadorCard}>
                        <div style={styles.jugadorNum}>#{i + 1}</div>
                        <div style={{ ...styles.jugadorAvatar, background: 'linear-gradient(135deg, #0D1117, #7C3AED)' }}>
                          {(p.nombre_companero || compañero)?.split(' ').map(x => x[0]).slice(0,2).join('') || '??'}
                        </div>
                        <div style={styles.jugadorInfo}>
                          <div style={styles.jugadorNombre}>Con {p.nombre_companero || compañero}</div>
                          <div style={styles.jugadorMeta}>
                            {p.celular_companero && <span style={{ color: '#1A6BFF' }}>📱 {p.celular_companero} · </span>}
                            <span style={{ color: '#16A34A' }}>{p.victorias || 0}V</span>
                            {' · '}
                            <span style={{ color: '#EF4444' }}>{derrotas}D</span>
                            {' · '}
                            <span>{p.partidos || 0} partidos</span>
                            {' · '}
                            <span style={{ color: winRate >= 50 ? '#16A34A' : '#EF4444' }}>{winRate}% vic.</span>
                          </div>
                        </div>
                        <div style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
                          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 20, fontWeight: 800, color: '#141922' }}>{p.elo || 1000}</div>
                          <div style={{ fontSize: 9, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" }}>ELO pareja</div>
                          <div style={{ display: 'flex', gap: 4 }}>
                            <button style={styles.btnEditarSmall}
                              onClick={() => { setEditandoPareja(p.id); setFormPareja({ nombre_companero: p.nombre_companero || compañero || '', celular_companero: p.celular_companero || '' }); }}>
                              ✏️
                            </button>
                            <button style={styles.btnEliminar} onClick={() => handleEliminarPareja(p.id)}>✕</button>
                          </div>
                        </div>
                      </div>
                      {/* Panel edición inline */}
                      {editandoPareja === p.id && (
                        <div style={{ background: '#F4F6FA', border: '1px solid #E8ECF4', borderRadius: 10, padding: '14px 16px', marginTop: 4 }}>
                          <div style={{ fontSize: 12, fontWeight: 700, color: '#6B7280', marginBottom: 10, fontFamily: "'Barlow', sans-serif" }}>
                            Editar pareja
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                            <div>
                              <div style={{ fontSize: 10, color: '#9BA5B7', marginBottom: 4, fontFamily: "'Barlow', sans-serif", textTransform: 'uppercase' }}>Nombre compañero</div>
                              <input style={styles.input} value={formPareja.nombre_companero}
                                onChange={e => setFormPareja(p => ({ ...p, nombre_companero: e.target.value }))}
                                placeholder="Nombre o apodo" />
                            </div>
                            <div>
                              <div style={{ fontSize: 10, color: '#9BA5B7', marginBottom: 4, fontFamily: "'Barlow', sans-serif", textTransform: 'uppercase' }}>Celular compañero</div>
                              <input style={styles.input} value={formPareja.celular_companero}
                                onChange={e => setFormPareja(p => ({ ...p, celular_companero: e.target.value }))}
                                placeholder="+56 9 1234 5678" />
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                            <button style={{ ...styles.btnCancelar, padding: '7px 14px' }} onClick={() => setEditandoPareja(null)}>Cancelar</button>
                            <button style={{ ...styles.btnGuardar, padding: '7px 14px', opacity: guardandoPareja ? 0.7 : 1 }}
                              onClick={handleGuardarPareja} disabled={guardandoPareja}>
                              {guardandoPareja ? 'Guardando...' : '✓ Guardar'}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          )
        )}

      </div>
    </div>
  );
}

const styles = {
  pagina: { minHeight: '100vh', background: '#F4F6FA' },
  header: { background: '#0D1117', padding: '20px 32px', borderBottom: '1px solid rgba(255,255,255,0.06)', marginBottom: 24 },
  headerInner: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 },
  titulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 30, fontWeight: 800, color: 'white', marginBottom: 2 },
  sub: { fontSize: 13, color: 'rgba(255,255,255,0.4)', fontFamily: "'Barlow', sans-serif" },
  selectorWrap: { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' },
  selectorLabel: { fontSize: 11, color: 'rgba(255,255,255,0.3)', fontFamily: "'Barlow', sans-serif", textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' },
  selectorChips: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  selectorChip: { padding: '6px 14px', borderRadius: 20, fontSize: 12, cursor: 'pointer', fontFamily: "'Barlow', sans-serif", transition: 'all 0.1s', display: 'flex', alignItems: 'center' },
  contenido: { padding: '0 32px 32px', maxWidth: 700 },
  equipoCard: { display: 'flex', alignItems: 'center', gap: 16, background: '#0D1117', borderRadius: 16, padding: '16px 20px', marginBottom: 16 },
  equipoEscudo: { width: 52, height: 52, borderRadius: 12, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 18, fontWeight: 800, color: 'white' },
  equipoInfo: { flex: 1 },
  equipoNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 20, fontWeight: 800, color: 'white', marginBottom: 2 },
  equipoMeta: { fontSize: 12, color: 'rgba(255,255,255,0.4)', fontFamily: "'Barlow', sans-serif", marginBottom: 6 },
  capRow: { display: 'flex', alignItems: 'center', gap: 6 },
  capIcono: { fontSize: 14 },
  capNombre: { fontSize: 12, color: 'rgba(255,255,255,0.6)', fontFamily: "'Barlow', sans-serif", fontWeight: 600 },
  capEmail: { fontSize: 11, color: 'rgba(255,255,255,0.3)', fontFamily: "'Barlow', sans-serif" },
  equipoAcciones: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 },
  eloTag: { background: 'rgba(255,107,26,0.2)', color: '#FF6B1A', fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 20, fontFamily: "'Barlow Condensed', sans-serif" },
  btnAgregar: { background: '#FF6B1A', color: 'white', border: 'none', borderRadius: 10, padding: '8px 14px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, fontWeight: 700 },
  btnEliminarEquipo: { background: 'transparent', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, padding: '5px 10px', color: '#EF4444', fontSize: 11, cursor: 'pointer', fontFamily: "'Barlow', sans-serif" },
  avisoEliminar: { background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 10, padding: '10px 14px', fontSize: 12, color: '#EF4444', fontFamily: "'Barlow', sans-serif", marginBottom: 16 },
  formCard: { background: 'white', border: '1px solid #E8ECF4', borderRadius: 14, padding: '20px', marginBottom: 16 },
  formTitulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 700, color: '#141922', marginBottom: 14 },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 },
  formLabel: { fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6, fontFamily: "'Barlow', sans-serif" },
  input: { width: '100%', padding: '10px 12px', border: '1.5px solid #E8ECF4', borderRadius: 10, fontSize: 13, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' },
  error: { color: '#EF4444', fontSize: 12, fontFamily: "'Barlow', sans-serif", marginBottom: 10 },
  formBotones: { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 },
  btnCancelar: { padding: '11px', background: 'white', border: '1.5px solid #E8ECF4', borderRadius: 10, fontSize: 14, fontWeight: 700, color: '#6B7280', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif" },
  btnGuardar: { padding: '11px', background: '#FF6B1A', border: 'none', borderRadius: 10, fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 800, color: 'white', cursor: 'pointer' },
  cargando: { fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", textAlign: 'center', padding: '40px' },
  listaHeader: { fontSize: 11, fontWeight: 700, color: '#9BA5B7', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: "'Barlow', sans-serif", marginBottom: 10 },
  vacio: { textAlign: 'center', padding: '40px 20px' },
  vacioIcono: { fontSize: 48, marginBottom: 16 },
  vacioTitulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 800, color: '#141922', marginBottom: 8 },
  vacioSub: { fontSize: 14, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", maxWidth: 360, margin: '0 auto 20px', lineHeight: 1.6 },
  btnAgregarGrande: { background: '#FF6B1A', color: 'white', border: 'none', borderRadius: 10, padding: '11px 24px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 700 },
  lista: { display: 'flex', flexDirection: 'column', gap: 8 },
  jugadorCard: { display: 'flex', alignItems: 'center', gap: 14, background: 'white', border: '1px solid #E8ECF4', borderRadius: 12, padding: '12px 16px' },
  jugadorNum: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 18, fontWeight: 800, color: '#9BA5B7', minWidth: 28, textAlign: 'center' },
  jugadorAvatar: { width: 38, height: 38, borderRadius: 10, background: 'linear-gradient(135deg, #FF6B1A, #1A6BFF)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, fontWeight: 800, color: 'white', flexShrink: 0 },
  jugadorInfo: { flex: 1 },
  jugadorNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 700, color: '#141922', marginBottom: 2 },
  jugadorMeta: { fontSize: 12, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  btnEliminar: { background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, width: 28, height: 28, fontSize: 11, cursor: 'pointer', color: '#EF4444', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  btnEditarSmall: { background: '#EFF5FF', border: '1px solid #BFDBFE', borderRadius: 8, width: 28, height: 28, fontSize: 13, cursor: 'pointer', color: '#1A6BFF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
};
